import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { shareReplay, map, tap } from 'rxjs/operators';
import { BasemapDescriptor, DownloadService, BaseMapService, VectorLayerService } from 'map-wald-leaflet';
import { VectorLayerDescriptor } from './data';
import { environment } from '../environments/environment';
import { InterpolationService } from 'map-wald';

@Injectable({
  providedIn: 'root'
})
export class ConfigService implements BaseMapService, VectorLayerService {
  vectorLayers$: Observable<VectorLayerDescriptor[]>;
  basemaps$: Observable<BasemapDescriptor[]>;
  dashboards$: Observable<DownloadService[]>;

  getConfig<T>(url:string): Observable<T> {
    return this.http.get<T>(url+`?_=${(new Date()).getTime()}`).pipe(shareReplay());
  }

  constructor(private http: HttpClient) {
    this.vectorLayers$ = this.getConfig<VectorLayerDescriptor[]>(environment.vectorConfig).pipe(
      map(layers=>{
        return layers.map(l=>{
          if(l.source){
            l.source = environment.geojsons + l.source + '.json';
          }
          if(l.tileLayers?.length&&!l.tiles){
            l.tiles = InterpolationService.interpolate(environment.tiles,l)
          }
          return l;
        });
      }),
      shareReplay()
    );

    this.basemaps$ = this.getConfig<BasemapDescriptor[]>(environment.basemapConfig);

    this.dashboards$ = this.getConfig<DownloadService[]>(environment.dashboards);
  }
}

